export default __webpack_public_path__ + "static/case2_img_4@2x-929e925a3b22da460729305847914162.webp";